import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { IVolunteerRole, isVolunteerBoardDisabledError } from './models';

export const VOLUNTEER_ROLES_KEY = '/volunteering/roles';

export const useVolunteerRolesQuery = ({
	includeArchived = false,
	enabled = true,
	impersonationContext,
}: {
	includeArchived?: boolean;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryKey: [VOLUNTEER_ROLES_KEY, includeArchived, impersonationContext?.account?.id],
		queryFn: async () => {
			const value = await userSession.webServiceHelper.callAsync<IVolunteerRole[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'volunteering/roles',
					queryParams: includeArchived ? { includeArchived: true } : {},
				}),
				'GET'
			);
			return value ?? [];
		},
		meta: {
			toastErrorMessage: (error: Error) => (isVolunteerBoardDisabledError(error) ? '' : 'Failed to load jobs'),
		},
	});
};

export const invalidateVolunteerRoles = () => reactQueryClient.invalidateQueries({ queryKey: [VOLUNTEER_ROLES_KEY] });
